import { Link } from 'react-router-dom';

export default function FinalCta() {
  return (
    <section className="section container">
      <div className="finalcta__inner">
        <div className="finalcta__blob finalcta__blob--1" aria-hidden="true" />
        <div className="finalcta__blob finalcta__blob--2" aria-hidden="true" />
        <h2 className="finalcta__title">Ready to get your time back?</h2>
        <p className="finalcta__text">
          Get your free list of required documents and policies in minutes. No credit card, no
          contract.
        </p>
        <div className="finalcta__actions">
          <Link to="/waitlist" className="btn btn-primary">
            Start for free
          </Link>
          <Link to="/waitlist" className="btn btn-on-dark">
            Book a demo
          </Link>
        </div>
      </div>
    </section>
  );
}
